module.exports = __webpack_public_path__ + "img/clear_all.aa1c9794.svg";